export const BUNDLED_RATE_TYPE_ID = 'bundled-rate-type';
export const DIY_RATE_TYPE_ID = 'diy-rate-type';
